'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import ErrorPage from '../blocks/ErrorPage';

type GlobalErrorProps = {
	error: Error & { digest?: string };
	reset: () => void;
};

export default function GlobalError( { error }: GlobalErrorProps ) {
	useEffect( () => {
		Sentry.captureException( error );
	}, [ error ] );

	return (
		<html lang='en'>
			<body>
				<ErrorPage statusCode={ 500 } />
			</body>
		</html>
	);
}
